/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Admin_Billing_Mode_Waive_DescInputs */



/**
* | output |
* | --- |
* | "The {count} reports totalling {amount} are written off and never invoiced. The current month bills in full at month-end." |
*
* @param {Partner_Admin_Billing_Mode_Waive_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_mode_waive_desc = /** @type {((inputs: Partner_Admin_Billing_Mode_Waive_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Mode_Waive_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die ${i?.count} Berichte über insgesamt ${i?.amount} werden erlassen und nie abgerechnet. Der aktuelle Monat wird zum Monatsende vollständig fakturiert.`)
	return /** @type {LocalizedString} */ (`The ${i?.count} reports totalling ${i?.amount} are written off and never invoiced. The current month bills in full at month-end.`)
});